import { BranchHoursNormalized, Standard } from 'hooks/solr/useBranchHours'

export const formatBranchHours = (branchHourData?: BranchHoursNormalized[] | null) => {
  if (!branchHourData) return 'Branch hours unavailable.'
  let formattedHours = ''
  branchHourData.forEach((branchDay: BranchHoursNormalized) => {
    //Note: Passing in local (to branch) timezone shifts day results backward. E.g. 12/2/2025 returns Mon intead of Tues
    const dayName = new Date(branchDay.day).toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' }) + ': '
    const dayStandard = branchDay.standard as Standard
    if (dayStandard.closed) {
      formattedHours += dayName + ' Closed '
    } else if (dayStandard.open24Hours) {
      formattedHours += dayName + ' 24 Hours '
    } else {
      formattedHours += dayName + dayStandard.hours[0].open + ' - ' + dayStandard.hours[0].close + ' '
    }
  })

  return formattedHours
}
